import {z} from "zod";

export const withdrawalSchema = z.object({
  pm_account_id: z.string().trim().min(1, "Selecciona una cuenta"),
  amount: z.coerce.number({message: "Monto inválido"}).positive("El monto debe ser mayor a 0"),
});

export type WithdrawalFormInput = z.input<typeof withdrawalSchema>;
export type WithdrawalPayload = z.output<typeof withdrawalSchema>;
